// import toast from "react-hot-toast";
import { Redirect, Route } from "react-router-dom";
import { toLoginSearch } from "utils/intendedUrl";

const PrivateRoute = ({
	component: Component,
	isAuthenticated,
	hasRight,
	...rest
}) => {
	const renderComponent = ({ location, ...props }) => {
		// User is authenticated and has the required rights
		if (isAuthenticated && hasRight) {
			return <Component {...props} />;
		}

		// User is authenticated but doesn't have the required rights
		if (isAuthenticated && !hasRight) {
			return <Redirect to="/access-denied" />;
		}

		// Open login over the home page and resume the protected destination after success.
		return (
			<Redirect
				to={{
					pathname: "/",
					search: toLoginSearch(location),
					state: { from: location },
				}}
			/>
		);
	};

	return (
		<Route
			render={renderComponent}
			{...rest}
		/>
	);
};

export default PrivateRoute;
